module.exports = __webpack_public_path__ + "app/img/webBG.75571bcb.jpg";